export var date = function (node) {
    var addLeadingZero = function (val) {
        if (val < 10) {
            return "0" + val;
        }
        return val;
    };
    var result = new Date(Number(node.attrs.timestamp));
    return "{{" + result.getUTCFullYear() + "-" + addLeadingZero(result.getUTCMonth() + 1) + "-" + addLeadingZero(result.getUTCDate()) + "}}";
};
//# sourceMappingURL=date.js.map